import { useState, useEffect, useRef } from 'react';
import { useLang } from '../../../hooks/useLang';

const tickerNews = [
  { tag: 'SFC公告', tagEn: 'SFC Notice', text: '香港证监会就代币化资产基金新发布监管指引，持牌机构须于2026年Q2完成合规升级', textEn: 'SFC issues new regulatory guidelines for tokenized asset funds; licensed institutions must complete compliance upgrades by Q2 2026', date: '2026-03-28', url: 'https://www.sfc.hk', hot: true },
  { tag: 'HKMA动态', tagEn: 'HKMA Update', text: 'Project Ensemble 沙盒第三阶段：四大行已完成债券代币化互联互通测试', textEn: 'Project Ensemble Sandbox Phase 3: Four major banks complete bond tokenization interoperability testing', date: '2026-03-27', url: 'https://www.hkma.gov.hk', hot: true },
  { tag: 'HashKey', tagEn: 'HashKey', text: 'HashKey Exchange 宣布推出首个在港合规房地产RWA产品，底层资产为九龙甲级写字楼', textEn: 'HashKey Exchange launches first compliant real estate RWA product in HK backed by Grade A office in Kowloon', date: '2026-03-26', url: 'https://hashkey.com', hot: false },
  { tag: '证监会', tagEn: 'CSRC', text: '中国证监会发布《数字资产代币化试点管理暂行办法（征求意见稿）》，限定在自贸区试点', textEn: 'CSRC releases draft trial management measures for digital asset tokenization, limited to free trade zones', date: '2026-03-25', url: 'http://www.csrc.gov.cn', hot: true },
  { tag: 'OSL', tagEn: 'OSL', text: 'OSL完成与恒生银行战略合作，推出面向私人银行客户的RWA托管服务', textEn: 'OSL completes strategic partnership with Hang Seng Bank, launching RWA custody services for private banking clients', date: '2026-03-24', url: 'https://osl.com', hot: false },
  { tag: 'BIS研究', tagEn: 'BIS Research', text: 'BIS发布2026全球代币化市场报告：RWA总规模突破2800亿美元，较2025年增长340%', textEn: 'BIS releases 2026 Global Tokenization Market Report: RWA total surpasses $280B, up 340% from 2025', date: '2026-03-23', url: 'https://www.bis.org', hot: true },
  { tag: 'BlackRock', tagEn: 'BlackRock', text: 'BlackRock BUIDL基金AUM突破120亿美元，已在香港二级市场获准交易', textEn: 'BlackRock BUIDL fund AUM surpasses $12B, approved for secondary market trading in Hong Kong', date: '2026-03-22', url: 'https://rwa.xyz', hot: false },
  { tag: 'HKEX', tagEn: 'HKEX', text: '港交所Digital Asset平台正式接受首批证券型代币上市申请，绿色债券优先审批', textEn: 'HKEX Digital Asset platform officially accepts first batch of security token listing applications, green bonds prioritized', date: '2026-03-21', url: 'https://www.hkex.com.hk', hot: false },
  { tag: 'MAS新加坡', tagEn: 'MAS Singapore', text: 'MAS Project Guardian发布第四阶段成果：跨境RWA结算T+0清算率达97%', textEn: 'MAS Project Guardian Phase 4 results: Cross-border RWA settlement achieves 97% T+0 clearing rate', date: '2026-03-20', url: 'https://www.mas.gov.sg', hot: false },
  { tag: '香港财政司', tagEn: 'HK FinSec', text: '财政司司长陈茂波：香港2026年数字资产产业目标贡献GDP达1.5%', textEn: 'FS Paul Chan: Hong Kong targets digital asset industry to contribute 1.5% GDP in 2026', date: '2026-03-19', url: 'https://www.hkma.gov.hk', hot: false },
];

export default function NewsTicker() {
  const { t } = useLang();
  const [currentIdx, setCurrentIdx] = useState(0);
  const [paused, setPaused] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const startInterval = () => {
    intervalRef.current = setInterval(() => {
      setCurrentIdx((prev) => (prev + 1) % tickerNews.length);
    }, 4000);
  };

  useEffect(() => {
    if (!paused) startInterval();
    return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
  }, [paused]);

  const current = tickerNews[currentIdx];

  return (
    <div
      className="bg-[#1A0050] border-b border-[#7C3AED]/30 py-2 px-0"
      onMouseEnter={() => { setPaused(true); if (intervalRef.current) clearInterval(intervalRef.current); }}
      onMouseLeave={() => { setPaused(false); }}
    >
      <div className="max-w-[1440px] mx-auto px-4 lg:px-8 flex items-center gap-3">
        {/* Label */}
        <div className="flex items-center gap-1.5 shrink-0">
          <span className="w-1.5 h-1.5 rounded-full bg-red-400 animate-pulse" />
          <span className="text-[#F59E0B] text-xs font-black tracking-widest whitespace-nowrap">
            {t('资讯速报', 'LIVE NEWS')}
          </span>
        </div>
        <div className="w-px h-4 bg-white/20 shrink-0" />

        {/* News item */}
        <div className="flex items-center gap-2 flex-1 min-w-0 overflow-hidden">
          <span
            className={`shrink-0 px-2 py-0.5 rounded text-[10px] font-bold whitespace-nowrap ${current.hot ? 'bg-red-500/20 text-red-300 border border-red-500/30' : 'bg-[#7C3AED]/20 text-[#A78BFA] border border-[#7C3AED]/30'}`}
          >
            {t(current.tag, current.tagEn)}
            {current.hot && <span className="ml-1 text-red-400">🔥</span>}
          </span>
          <a
            href={current.url}
            target="_blank"
            rel="nofollow noreferrer"
            className="text-white/75 text-xs truncate hover:text-[#F59E0B] transition-colors cursor-pointer"
          >
            {t(current.text, current.textEn)}
          </a>
          <span className="text-white/30 text-[10px] shrink-0 hidden sm:block">{current.date}</span>
        </div>

        {/* Navigation */}
        <div className="flex items-center gap-1 shrink-0">
          <button
            onClick={() => setCurrentIdx((prev) => (prev - 1 + tickerNews.length) % tickerNews.length)}
            className="w-5 h-5 flex items-center justify-center text-white/40 hover:text-white/80 cursor-pointer transition-colors"
          >
            <i className="ri-arrow-left-s-line text-sm" />
          </button>
          <span className="text-white/30 text-[10px]">{currentIdx + 1}/{tickerNews.length}</span>
          <button
            onClick={() => setCurrentIdx((prev) => (prev + 1) % tickerNews.length)}
            className="w-5 h-5 flex items-center justify-center text-white/40 hover:text-white/80 cursor-pointer transition-colors"
          >
            <i className="ri-arrow-right-s-line text-sm" />
          </button>
          <a
            href="#news-feed"
            className="ml-1 text-[#F59E0B] text-[10px] font-bold whitespace-nowrap hover:underline cursor-pointer"
          >
            {t('全部资讯 →', 'All News →')}
          </a>
        </div>
      </div>
    </div>
  );
}
